import React, { Children } from 'react';

import './NonSignedInContentLayout.css'

/**
 * A simple layout for showing content to a user when they are not signed in.
 * This should be the root component of the view, not embeded in other components.
 */
export default class NonSignedInContentLayout extends React.PureComponent {
    public render() {
        return (
            <div className="not-signed-in-content-layout">
                <div className="container">
                    <header>
                        <img src="/images/homepage/3e-exchange-logo-color-rgb.svg" />
                    </header>
                </div>
                <div className="hero">
                    <div className="container">
                        <div className="content">
                            {this.props.children}
                        </div>
                    </div>
                    <div className="section-separator"></div>
                </div>
            </div>
        );
    }
}